export default __webpack_public_path__ + "static/media/gm-sb-girl.4a0a19f3.webp";